import { c as _c } from "react/compiler-runtime";
import { Button, HStack, Spinner } from '@chakra-ui/react';
import { PendingAttachment } from '@src/components/sco/Comments/CommentAttachments/types';
import React from 'react';
import { LuFile, LuX } from 'react-icons/lu';
function truncateTitle(title: string, max = 28) {
  if (title.length <= max) {
    return title;
  }
  return `${title.slice(0, max - 1)}…`;
}
type CommentPendingAttachmentsProps = {
  files: PendingAttachment[];
  onRemove: (localKeyOrStoredFileId: string) => void;
  disabled?: boolean;
};
export const CommentPendingAttachments = props => {
  const $ = _c(4);
  if (!props.files?.length) {
    return null;
  }
  let t0;
  if ($[0] !== props) {
    t0 = props.files.map(file => {
      const removeKey = file.storedFileId || file.localKey;
      return <Button key={file.localKey || file.storedFileId} borderRadius="0.25em" borderWidth="1px" disabled={props.disabled} maxWidth="260px" size="xs" title={file.title} variant="outline" onClick={e => {
        e.preventDefault();
        if (!file.isUploading) {
          props.onRemove(removeKey);
        }
      }}>{file.isUploading ? <Spinner size="xs" /> : <LuFile />}<span style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: "140px"
        }}>{truncateTitle(file.title)}</span>{!file.isUploading && <LuX />}</Button>;
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <HStack gap={1} paddingTop={2} wrap="wrap">{t0}</HStack>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};